<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-layout justify-center>
        <v-dialog v-model="show"  transition="dialog-bottom-transition" width="600px">
            <v-card>
                <v-toolbar dark color="blue lighten-2" >
                    <v-btn icon dark @click="show = false">
                        <v-icon>close</v-icon>
                    </v-btn>
                    <v-toolbar-title>Профиль</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-toolbar-items>
                        <v-btn dark text @click="saveValue" >
                            <v-icon>save</v-icon>
                            Сохранить
                        </v-btn>
                    </v-toolbar-items>
                </v-toolbar>
                <v-list three-line subheader class="content">
                    <v-container fluid>
                            <v-row no-gutters>
                                <v-col cols="12" class="pa-0 px-4">
                                    <v-text-field
                                            v-model="userModel.user_id"
                                            label="Ваш id"
                                            required
                                            readonly
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row no-gutters>
                                <v-col cols="12" class="pa-0 px-4">
                                    <v-text-field
                                            v-model="userModel.username"
                                            label="Ник"
                                            required
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row no-gutters>
                                <v-col cols="12" class="pa-0 px-4">
                                    <v-text-field
                                            v-model="userModel.email"
                                            label="Email"
                                            required
                                            readonly
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row no-gutters>
                                <v-col cols="7" md="5" class="pa-0 pl-4">
                                    <v-checkbox class="pa-0 ma-2"
                                      v-model="userModel.token_vk"
                                      label="Подключен к Вк"
                                      readonly
                                      color="success"
                                    ></v-checkbox>
                                </v-col>
                                <v-col cols="5" class="pa-0">
                                    <v-btn color="primary" :disabled="userModel.token_vk"
                                            block
                                           :href="urlConnectUserToVK" target="_blank"
                                    >
                                        Подключить
                                    </v-btn>
                                </v-col>
                            </v-row>
                            <v-row no-gutters>
                                <v-col cols="6" class="pa-0 px-4">
                                    <v-text-field
                                            v-model="userModel.currentPassword"
                                            type="password"
                                            label="Старый пароль"
                                            required
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="6" md4 class="pa-0 pr-4">
                                    <v-text-field
                                            v-model="userModel.newPassword"
                                            type="password"
                                            label="Новый пароль"
                                            required
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="6" md4 class="pa-0 px-4">
                                    <v-text-field
                                            v-model="userModel.newPasswordRepeat"
                                            type="password"
                                            label="Подтверждение нового пароля"
                                            required
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="6" md4 class="pa-0 mt-3">
                                    <v-btn color="primary" :disabled="!changePasswordBool" @click="changePassword" block>
                                        <span class="text-capitalize">Изменить пароль</span>
                                    </v-btn>
                                </v-col>
                            </v-row>
                        <v-row no-gutters>
                            <v-col
                                    v-for="menuItem in userConstantsComputed.menuItems"
                                    cols="12" xs12 class="ma-0 py-1 px-4">
                                <v-switch
                                        class="ma-0 pa-0"
                                        inset
                                        :label="menuItem.title" color="primary"
                                        :false-value="+0"
                                        :true-value="+1"
                                        :value="interfaceParams[menuItem.interfaceIndex]"
                                        @change="setParam(menuItem.interfaceIndex)"
                                ></v-switch>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-list>
            </v-card>
        </v-dialog>
        <v-snackbar
                v-model="snackbar"
                bottom
                :color="paramsSnackbar.color"
                right
        >
            {{paramsSnackbar.text}}
            <v-btn
                    dark
                    text
                    @click="snackbar = false"
            >
                Закрыть
            </v-btn>
        </v-snackbar>
    </v-layout>
</template>

<script>

import { mapGetters } from 'vuex'
import constConf from '../../../constconf'
import userConstants from './userConstants'
export default {
    name: 'EventForm',
    props: ['index', 'dialog', 'edit'],
    data() {
        return {
            show: false,
            isActive: false,
            snackbar: false,
            eventModel: null,
            userModel: { wall_token_vk: null },
            paramsSnackbar: {
                color: 'success',
                text: 'Успешно сохранено!'
            },
            urlConnectUserToVK: 'https://oauth.vk.com/authorize?client_id=' +
                constConf.client_id +
                '&redirect_uri=' +
                constConf.baseURLApi +
                '/authorize/save-token' +
                '&display=popup&scope=groups,offline,market,photos,wall&response_type=code&revoke=1&v=5.92',
            urlConnectUserToWallVK: 'https://oauth.vk.com/authorize?client_id=' +
                constConf.client_id +
                '&redirect_uri=https://oauth.vk.com/blank.html' +
                '&display=popup&scope=groups,offline,market,photos,wall&response_type=code&revoke=1&v=5.92',
            redirectURL: '',
            interfaceMain: 0
        }
    },
    methods: {
        saveValue() {
            if (this.userModel.newPassword !== this.userModel.newPasswordRepeat) {
                this.paramsSnackbar.color = 'error'
                this.paramsSnackbar.text = 'Пароли не совпадают, изменения не сохранены'
                this.snackbar = true
                this.$store.dispatch('user/deletePasswordsInForm')
            } else {
                this.$store.dispatch('user/saveUser', this.userModel).then(response => {
                    if (!response.data.hasOwnProperty('error')) {
                        this.paramsSnackbar.color = 'success'
                        this.paramsSnackbar.text = 'Успешно сохранено!'
                        this.snackbar = true
                    } else {
                        this.paramsSnackbar.color = 'error'
                        this.paramsSnackbar.text = response.data.error.text
                        this.snackbar = true
                    }
                })
            }
        },
        changePassword() {
            if (this.userModel.newPassword !== this.userModel.newPasswordRepeat) {
                this.paramsSnackbar.color = 'error'
                this.paramsSnackbar.text = 'Пароли не совпадают, изменения не сохранены'
                this.snackbar = true
            } else {
                this.$store.dispatch('user/changePassword', this.userModel).then(response => {
                    if (!response.data.hasOwnProperty('error')) {
                        this.paramsSnackbar.color = 'success'
                        this.paramsSnackbar.text = 'Пароль успешно изменен!'
                        this.snackbar = true
                    } else {
                        this.paramsSnackbar.color = 'error'
                        this.paramsSnackbar.text = response.data.error.text
                        this.snackbar = true
                    }
                })
            }
            this.$store.dispatch('user/deletePasswordsInForm')
        },
        getParam(index) {
            let value = this.userModel.interface_main & (1 << index)
            return value >= 1 ? 1 : 0
        },
        setParam(index) {
            let value = this.getParam(index)
            this.userModel.interface_main = !value ? this.userModel.interface_main | (1 << index) : this.userModel.interface_main & (~(1 << index))
        }
    },
    watch: {
        dialog() {
            this.show = this.dialog === true
        },
        show() {
            if (this.show === false) {
                this.$emit('close')
            } else {
                this.$store.dispatch('user/loadUser', { data: '', request: 'userForm. if show == true' }).then(response => {
                    this.userModel = Object.assign({}, this.user)
                })
            }
        },
        '$route' (to, from) {
            this.redirectURL = window.location.href
        }
    },
    computed: {
        ...mapGetters({
            user: 'user/user',
            userLoaded: 'user/userLoaded'
        }),
        changePasswordBool() {
            if (this.userModel.currentPassword) {
                return this.userModel.currentPassword.length > 5 && this.userModel.newPassword.length > 5 && this.userModel.newPasswordRepeat.length > 5
            } else {
                return false
            }
        },
        userConstantsComputed() {
            return userConstants
        },
        /**
         * Description Расчет для выбора кнопок
         */
        interfaceParams() {
            let views = []
            if (this.userModel && this.userModel.interface_main) {
                for (let i = 0; i < userConstants.menuItems.length; i++) {
                    views[i] = ((this.userModel.interface_main & (1 << i)) >= 1) ? 1 : 0
                } 
            }
            return views
        }
    },
    created() {
        this.redirectURL = window.location.href
    }
}
</script>

<style scoped lang="scss">
    ::-webkit-scrollbar {
        width: $width-scroll-panel;
    }

    /* Track */
    ::-webkit-scrollbar-track {
        background: $light;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
        background: $blue-active ;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
        background: $blue-inactive;
    }
    .container {
      width: 100vw;
      height: 70vh;
      display: flex;
      flex-direction: column;
    }
    .titlebar {
      flex-shrink: 0;
    }

    .content {
      flex-grow: 1;
      overflow-x: auto;
    }
</style>
